export enum UserActionTypes {
  API_RESPONSE_SUCCESS = '@@user/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR = '@@user/API_RESPONSE_ERROR',

  LIST_USERS = '@@user/LIST_USERS',
  CREATE_USER = '@@user/CREATE_USER',
  DELETE_USER = '@@user/DELETE_USER',

  RESET = '@@user/RESET',
}